import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=bac67b52&scoped=true&lang=css"

import exportComponent from "/Users/dioratar/Documents/_project/omni/repo/emetrai/event-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bac67b52"]])

export default __exports__